import history from 'app/history';
import React, { useEffect } from 'react';
import useStyles from './styles';

interface IProps {
}

const Layout: React.FC<IProps> = (props) => {
  const { children } = props;
  const classes = useStyles();

  useEffect(() => {
    const unlisten = history.listen(() => {
      window.scrollTo(0, 0);
    });

    return () => {
      unlisten();
    };
  }, []);

  return (
    <div className={classes.root}>{children}</div>
  );
};

export default Layout;
